import React from 'react'

const Loader = (props) => {
    const { width = '50px', height = '50px', color = '#FF893A' } = props;
    return (
        <svg
            version="1.1"
            id="Layer_1"
            x="0px"
            y="0px"
            width={width}
            height={height}
            viewBox="0 0 24 30"
        >
            <rect x="0" y="13" width="4" height="5" fill={color}>
                <animate
                    attributeName="height"
                    attributeType="XML"
                    values="5;21;5"
                    begin="0s"
                    dur="0.6s"
                    repeatCount="indefinite"
                ></animate>
                <animate
                    attributeName="y"
                    attributeType="XML"
                    values="13; 5; 13"
                    begin="0s"
                    dur="0.6s"
                    repeatCount="indefinite"
                ></animate>
            </rect>
            <rect x="10" y="13" width="4" height="5" fill={color}>
                <animate
                    attributeName="height"
                    attributeType="XML"
                    values="5;21;5"
                    begin="0.15s"
                    dur="0.6s"
                    repeatCount="indefinite"
                ></animate>
                <animate
                    attributeName="y"
                    attributeType="XML"
                    values="13; 5; 13"
                    begin="0.15s"
                    dur="0.6s"
                    repeatCount="indefinite"
                ></animate>
            </rect>
            <rect x="20" y="13" width="4" height="5" fill={color}>
                <animate
                    attributeName="height"
                    attributeType="XML"
                    values="5;21;5"
                    begin="0.3s"
                    dur="0.6s"
                    repeatCount="indefinite"
                ></animate>
                <animate
                    attributeName="y"
                    attributeType="XML"
                    values="13; 5; 13"
                    begin="0.3s"
                    dur="0.6s"
                    repeatCount="indefinite"
                ></animate>
            </rect>
        </svg>
    );
};

export default Loader